import * as React from "react";
import {Edit, SimpleForm} from "react-admin";
import {CalendarEventFormFields, CalendarEventToolbar} from "./form";

export const EditCalendarEvent = () => (
    <div className="edit-customer">
        <h2 className="dailyTitle">Edit Calendar Event</h2>
        <Edit title="Calendar Events" actions={<></>}>
            <SimpleForm toolbar={<CalendarEventToolbar className="customerActionToolbar edit-user-btns" />}>
                <CalendarEventFormFields />
            </SimpleForm>
        </Edit>
    </div>
);
